import { OrderStatusObject } from './order-status-object.model';

export class OrderObject {

  constructor(public orderId: string, public incomingDate: Date, public lastModification: Date, public status: OrderStatusObject,
    public operation: string, public client: string, public serviceId: string,
    public crmId: string, public project: string) {
  }

}
